export enum LoginState {
  PHONENUMBER,
  OTP,
  PIN,
  RULES,
  REPRESENTATIVE,
  CHANGEPHONENUMBER,
}
